import styled from "styled-components";

const Heading = ({ level, children, className, ...props }) => {
  const Tag = `${level}`;
  return <Tag className={`section__title ${className}`} {...props}>{children}</Tag>;
};

const SectionTitle = ({ children, level = "h2", className, ...props }) => {
  return (
    <HeadingFront className={className} level={level} {...props}>
      {children}
    </HeadingFront>
  );
};

const SectionBackTitle = ({ children, level = "h3", className, ...props }) => {
  return (
    <HeadingBack className={className} level={level} {...props}>
      {children}
    </HeadingBack>
  );
};

export { SectionTitle, SectionBackTitle };

const HeadingBack = styled(Heading).attrs({
  className: "HeadingBack",
})`
  color: ${(props) => props.theme.colors.greyDark};
  text-align: center;
  font-size: 4.2rem;
  line-height: 1.4;
  margin-bottom: -50px;
  font-family: ${(props) => props.theme.fonts.title};
  @media screen and (max-width: 768px) {
    font-size: 3rem;
  }
`;

const HeadingFront = styled(Heading).attrs({
  className: "HeadingFront",
})`
  font-family: ${(props) => props.theme.fonts.title};
  color: ${(props) => props.theme.colors.blue};
  text-align: center;
  font-size: 3.8rem;
  line-height: 1.4;
  @media screen and (max-width: 768px) {
    font-size: 2.6rem;
  }
`;
